import MenuSection from "../MenuSection";
import React from "react";
import { MenuItemFactory } from "../MenuItemFactory";
import { useMemo } from "react";
import { useMobileCategories } from "./hooks/useMobileCategories";

const CategoriesMobile = () => {
  const menuItems = useMobileCategories();
  const components = useMemo(
    () =>
      menuItems?.map(menuItem => (
        <MenuItemFactory
          key={menuItem.key}
          componentProps={menuItem.props}
          componentType={menuItem.componentType}
        />
      )),
    [menuItems]
  );
  return <MenuSection className="categoriesSection">{components}</MenuSection>;
};

export default React.memo(CategoriesMobile);
